import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'
import type { AthleticsCatalog } from '@/types/enrollments'

// GET /ajax/athletics/catalog — season order/labels and sport icons (DTA-799)
export const athleticsCatalog = async (): Promise<AthleticsCatalog> => {
  const response = await new Request().get('/ajax/athletics/catalog')
  return Util.Obj.keysToCamel({
    seasons: response.data.seasons ?? [],
    sports: response.data.sports ?? [],
    session_types: response.data.session_types ?? []
  }) as AthleticsCatalog
}
